import { AppPermission, PermissionKey } from 'shared/types';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
  login: 'demo-pcq.login',
  i2puser: 'demo-pcq.i2puser',
  accuflow: 'demo-pcq.accuflow',
  cimtec: 'demo-pcq.cimtec',
  ffp: 'demo-pcq.ffp',
  triangle: 'demo-pcq.triangle',
  accutech: 'demo-pcq.accutech',
  teamtechnical: 'demo-pcq.teamtechnical',
  ffpnorth: 'demo-pcq.ffpnorth',
  texas: 'demo-pcq.texas',
  tulsa: 'demo-pcq.tulsa',
  cbe: 'demo-pcq.cbe',
  lewis: 'demo-pcq.lewis',
  qualitystainless: 'demo-pcq.qualitystainless',
  indelco: 'demo-pcq.indelco',
  corrtech: 'demo-pcq.corrtech',
  inscoprocess: 'demo-pcq.inscoprocess',
  nianticseal: 'demo-pcq.nianticseal',
  newgen: 'demo-pcq.newgen',
  prestonphipps: 'demo-pcq.prestonphipps',
  sepump: 'demo-pcq.sepump',
  shaltzautomation: 'demo-pcq.shaltzautomation',
  triphase: 'demo-pcq.triphase',
  rankin: 'demo-pcq.rankin',
  smithcameron: 'demo-pcq.smithcameron',
};
